export default __webpack_public_path__ + "static/media/background-video-still.9a157244.png";